import { IXC_REGISTRATION_V1_PROFILE_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-registration-v1-profile-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcRegistrationV1ProfileStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../../util/entity-status-variants';

interface ProfileStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcRegistrationV1ProfileStatus | undefined;
}

export function ProfileStatusPill({ isPending, status, ...props }: ProfileStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXC_REGISTRATION_V1_PROFILE_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixcRegistrationV1', enumName: 'IxcRegistrationV1ProfileStatus', value: status }} />
    </Pill>
  );
}
